
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AccountPlan, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class AccountPlanEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    accountPlan: AccountPlan;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getAccountPlan()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getAccountPlan(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.accountPlan = data;
                this.onDataChanged.next(this.accountPlan);
                resolve(this.accountPlan);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('accountPlan/' + this.routeParams.id).subscribe((res: AccountPlan ) => {
                    this.accountPlan = res;
                    this.onDataChanged.next(this.accountPlan);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(accountPlan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('accountPlan/', accountPlan).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(accountPlan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('accountPlan/', accountPlan).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(accountPlan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('accountPlan/' + accountPlan.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

     linkCompanyAccountPlan(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put(`accountPlan/link-company-account-plan`).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): AccountPlan {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }

    editCompanyACcountPlan(companyAccountPlan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('accountPlan/companyAccountPlan/', companyAccountPlan).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
